// 定数定義
const BREAKPOINTS = {
	SP: 559,
	TABLET: 959
};

const SCROLL_SPEED = 800;
const SCROLL_EASING = 'easeOutExpo';

//画面サイズごとの処理
$(window).on('load resize', function(){
	deviceSizeFunc({
		sp: handleSmartphoneView,
		tablet: function() {
			// タブレット用の処理
		},
		pc: function() {
			// PC用の処理
		},
		overSp: handleOverSmartphoneView
	});
});

// スマートフォン表示の処理
function handleSmartphoneView() {
	$(".tel-number").each(function(){
		if(!$(this).parent(".tel-wrap").length){
			const no = $(this).data("tel").replace(/-/g,"");
			$(this).wrap('<a href="tel:' + no + '" class="tel-wrap"></a>');
		}
	});	
}

// スマートフォンより大きい画面の処理
function handleOverSmartphoneView() {
	$(".tel-wrap .tel-number").each(function(){
		$(this).unwrap();
	});
}

// アンカーリンクのスムーズスクロール
$('a[href^="#"]').on('click', function() {
	const isMenuAnchorOnTablet = $(this).closest('.gnavi-item').length
		&& $(window).width() <= BREAKPOINTS.TABLET
		&& $('body').hasClass('menu-open');

	// メニュー内アンカー（タブレット以下でメニュー表示中）は
	// initMenu 側の専用処理で閉じる→スクロールを行う
	if (isMenuAnchorOnTablet) {
		return;
	}

	const href = $(this).attr('href');
	scrollToAnchor(href);
	return false;
});



$(document).ready(function(){
	//ブラウザとOSの情報をbodyに付与
	const systemInfo = getSystemInfo();
	if (systemInfo.browser) {
		$('body').addClass(systemInfo.browser);
	}
	if (systemInfo.os) {
		$('body').addClass(systemInfo.os);
	}
  
	//Menu
	initMenu();

	// logo slider (Swiper)
	initLogoSlider();

	// case slider (Swiper)
	initCaseSlider();
	
});

// メニュー機能の初期化
function initMenu() {
	let isMenuOpen = false;
	let scrollPosition;

	function openMenu() {
		scrollPosition = $(window).scrollTop();
		$("body")
			.addClass("fixed")
			.css({"position": "fixed", "top": -scrollPosition})
			.addClass("menu-open");
		isMenuOpen = true;
	}

	function closeMenu() {
		$("body")
			.removeClass("fixed")
			.css({"position": "", "top": ""})
			.removeClass("menu-open");
		window.scrollTo(0, scrollPosition);
		isMenuOpen = false;
	}
	
	$("#menu-btn").on("click", function() {
		if (!isMenuOpen) {
			openMenu();
		} else {
			closeMenu();
		}
	});

	$(".gnavi-item a[href^='#']").on("click", function(e) {
		const isTabletOrLess = $(window).width() <= BREAKPOINTS.TABLET;
		if (!isTabletOrLess || !isMenuOpen) {
			return;
		}

		const href = $(this).attr("href");
		e.preventDefault();
		e.stopImmediatePropagation();

		closeMenu();
		scrollToAnchor(href);
	});
}

function scrollToAnchor(href) {
	const target = $(href == '#' || href == '' ? 'html' : href);
	if (!target.length) {
		return;
	}
	const headerHeight = $('header').outerHeight();
	const position = target.offset().top - headerHeight;
	$('html, body').animate({scrollTop: position}, SCROLL_SPEED, SCROLL_EASING);
}

// ロゴスライダー（Swiper 無限ループ）
function initLogoSlider() {
	if (typeof Swiper === 'undefined' || !document.querySelector('.logo-loop-list')) {
		return;
	}
	var logoSlider=$('.logo-loop-list').bxSlider({
		speed:50000,
		ticker: true,
		useCSS: false
	});
}

// 導入事例スライダー（中央1枚メイン・両隣チラ見せ・3枚目開始・高さはflexで揃え）
function initCaseSlider() {
	if (typeof Swiper === 'undefined' || !document.querySelector('.case-slider-js')) {
		return;
	}
	new Swiper('.case-slider-js', {
		loop: true,
		initialSlide: 1,
		slidesPerView: 'auto',
		centeredSlides: true,
		centeredSlidesBounds: false,
		spaceBetween: 40,
		slidesPerGroup: 1,
		speed: 500,
		watchOverflow: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: '#case .case-slider-next',
			prevEl: '#case .case-slider-prev',
		},
		pagination: {
			el: '#case .case-slider-pagination',
			clickable: true,
			type: 'bullets',
			bulletElement: 'button',
		},
	});
}

function deviceSizeFunc(callback) {
	const w = $(window).width();
	
	if(w <= BREAKPOINTS.SP) {
		// スマートフォン向け処理
		if(typeof callback.sp === 'function') {
			callback.sp();
		}
	} else if(w <= BREAKPOINTS.TABLET) {
		// タブレット向け処理
		if(typeof callback.tablet === 'function') {
			callback.tablet(); 
		}
	} else {
		// PC向け処理
		if(typeof callback.pc === 'function') {
			callback.pc();
		}
	}

	// スマートフォンより大きい場合の処理
	if(w > BREAKPOINTS.SP) {
		if(typeof callback.overSp === 'function') {
			callback.overSp();
		}
	}
}

function getSystemInfo() {
	const ua = navigator.userAgent.toLowerCase();
	let browserClass = '';
	let osClass = '';

	// ブラウザ判定
	if (ua.indexOf('edge') !== -1 || ua.indexOf('edg') !== -1) {
		browserClass = 'browser-edge';
	} else if (ua.indexOf('opera') !== -1 || ua.indexOf('opr') !== -1) {
		browserClass = 'browser-opera'; 
	} else if (ua.indexOf('chrome') !== -1) {
		browserClass = 'browser-chrome';
	} else if (ua.indexOf('safari') !== -1) {
		browserClass = 'browser-safari';
	} else if (ua.indexOf('firefox') !== -1) {
		browserClass = 'browser-firefox';
	} else if (ua.indexOf('msie') !== -1 || ua.indexOf('trident') !== -1) {
		browserClass = 'browser-ie';
	}

	// OS判定
	if (ua.indexOf('windows') !== -1) {
		osClass = 'os-windows';
	} else if (ua.indexOf('mac os x') !== -1) {
		osClass = 'os-mac';
	} else if (ua.indexOf('iphone') !== -1 || ua.indexOf('ipad') !== -1 || ua.indexOf('ipod') !== -1) {
		osClass = 'os-ios';
	} else if (ua.indexOf('android') !== -1) {
		osClass = 'os-android';
	} else if (ua.indexOf('linux') !== -1) {
		osClass = 'os-linux';
	}

	return {
		browser: browserClass,
		os: osClass
	};
}
